export default __webpack_public_path__ + "static/media/sofia_s.e2f606d6.jpg";